/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ContributoFasciaDTO { 
    id?: string;
    soglia_max?: number;
    importo?: number;
    ordine?: number;
    version?: number;
}

